import { TIconProps } from "./iconProps";

const DotArrowRight = ({ fontSize = 24, className }: TIconProps) => {
  return (
    <svg width="17" height="14" viewBox="0 0 17 14" fill="none">
      <g opacity="0.24">
        <rect
          y="5"
          width="4"
          height="4"
          rx="2"
          fill="black"
          fillOpacity="0.66"
        />
      </g>
      <g opacity="0.24">
        <rect
          x="6"
          y="5"
          width="4"
          height="4"
          rx="2"
          fill="black"
          fillOpacity="0.66"
        />
      </g>
      <rect x="12" y="4.5" width="5" height="5" rx="2.5" fill="black" />
      <rect x="9.5" width="3" height="3" rx="1.5" fill="black" />
      <rect x="9.5" y="11" width="3" height="3" rx="1.5" fill="black" />
    </svg>
  );
};

export default DotArrowRight;
